/**
 * fs-select.js — custom themed dropdown (combobox) behavior.
 * Delegated on document → works for AJAX-injected selects too. Idempotent.
 *
 * Each .fs-select holds: a hidden native <select> (source of truth + form submit),
 * a trigger button, and a listbox panel. Selecting an option updates the native
 * select's value AND dispatches a native 'change' event on it — so existing code
 * that listens to the <select> keeps working unchanged.
 *
 * Keyboard: Enter/Space/Down opens; Up/Down move; Enter/Space select; Esc closes.
 * Reduced-motion respected via CSS.
 */
(function () {
  'use strict';
  if (window.__fsSelectInit) return;
  window.__fsSelectInit = true;

  var openEl = null;

  function panelOf(root) { return root.querySelector('[data-fs-select-panel]'); }
  function triggerOf(root) { return root.querySelector('[data-fs-select-trigger]'); }
  function nativeOf(root) { return root.querySelector('[data-fs-select-native]'); }
  function valueOf(root) { return root.querySelector('[data-fs-select-value]'); }
  function opts(root) { return Array.prototype.slice.call(root.querySelectorAll('.fs-select__opt')); }

  function open(root) {
    if (openEl && openEl !== root) close(openEl);
    root.setAttribute('data-open', '');
    triggerOf(root).setAttribute('aria-expanded', 'true');
    var panel = panelOf(root); panel.hidden = false;
    openEl = root;
    // mark active = current selected
    var sel = root.querySelector('.fs-select__opt.is-selected') || opts(root)[0];
    setActive(root, sel);
    if (sel) sel.scrollIntoView({ block: 'nearest' });
    panel.focus();
  }
  function close(root) {
    root.removeAttribute('data-open');
    triggerOf(root).setAttribute('aria-expanded', 'false');
    panelOf(root).hidden = true;
    opts(root).forEach(function (o) { o.classList.remove('is-active'); });
    if (openEl === root) openEl = null;
  }
  function setActive(root, opt) {
    opts(root).forEach(function (o) { o.classList.remove('is-active'); });
    if (opt) opt.classList.add('is-active');
  }
  function activeIndex(root) {
    return opts(root).findIndex(function (o) { return o.classList.contains('is-active'); });
  }
  function choose(root, opt) {
    if (!opt) return;
    opts(root).forEach(function (o) { o.classList.remove('is-selected'); o.setAttribute('aria-selected', 'false'); });
    opt.classList.add('is-selected'); opt.setAttribute('aria-selected', 'true');
    var v = opt.getAttribute('data-value');
    valueOf(root).textContent = opt.textContent.trim();
    var nat = nativeOf(root);
    if (nat && nat.value !== v) {
      nat.value = v;
      nat.dispatchEvent(new Event('change', { bubbles: true }));
    }
    close(root);
    triggerOf(root).focus();
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-fs-select-trigger]');
    if (trigger) {
      var root = trigger.closest('[data-fs-select]');
      if (root.hasAttribute('data-open')) close(root); else open(root);
      return;
    }
    var opt = e.target.closest('.fs-select__opt');
    if (opt) { choose(opt.closest('[data-fs-select]'), opt); return; }
    // click outside → close
    if (openEl && !e.target.closest('[data-fs-select]')) close(openEl);
  });

  document.addEventListener('keydown', function (e) {
    var root = e.target.closest('[data-fs-select]');
    if (!root) return;
    var isOpen = root.hasAttribute('data-open');
    var list = opts(root);

    if (!isOpen) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') { e.preventDefault(); open(root); }
      return;
    }
    // open state
    if (e.key === 'Escape') { e.preventDefault(); close(root); triggerOf(root).focus(); return; }
    if (e.key === 'ArrowDown') { e.preventDefault(); var i = Math.min(activeIndex(root) + 1, list.length - 1); setActive(root, list[i]); list[i].scrollIntoView({ block: 'nearest' }); return; }
    if (e.key === 'ArrowUp') { e.preventDefault(); var j = Math.max(activeIndex(root) - 1, 0); setActive(root, list[j]); list[j].scrollIntoView({ block: 'nearest' }); return; }
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(root, list[activeIndex(root)]); return; }
    if (e.key === 'Home') { e.preventDefault(); setActive(root, list[0]); return; }
    if (e.key === 'End') { e.preventDefault(); setActive(root, list[list.length - 1]); return; }
  });
})();
